import type { Mission } from '../missions.ts'

export const nrcs: Mission = {
  id: "nrcs",
  name: "Natural Resources Conservation Service",
  short: "NRCS",
  call: "Conservation",
  kind: "subagency",
  parent: "usda",
  url: "https://www.nrcs.usda.gov/",
  established: 1935,
  palette: {
    primary: "#007ac2",
    secondary: "#31251c",
    accent: "#00a886",
  },
  colorSource: {
    kind: "site",
    url: "https://www.nrcs.usda.gov/",
  },
  motif: "wave",
  mission: {
    text: "We deliver practical, voluntary, and locally led conservation solutions that help producers conserve natural resources, strengthen agricultural production, and keep working lands productive for generations to come.",
    url: "https://www.nrcs.usda.gov/about",
  },
  fact: {
    text: "NRCS began in 1935, during the Dust Bowl, as the USDA Soil Conservation Service.",
    url: "https://www.nrcs.usda.gov/about",
  },
  logo: {
    file: "public/logos/nrcs.svg",
    source: "https://commons.wikimedia.org/wiki/File:US-NaturalResourcesConservationService-Logo.svg",
  },
  identifier: {
    about: "https://www.nrcs.usda.gov/about",
    accessibility: "https://www.usda.gov/accessibility-statement",
    foia: "https://www.nrcs.usda.gov/foia",
    noFear: "https://www.nrcs.usda.gov/no-fear-act",
    oig: "https://www.oig.usda.gov/",
    performance: "https://www.nrcs.usda.gov/performace",
    privacy: "https://www.nrcs.usda.gov/privacy",
  },
  media: {
    photos: [
      {
        file: "/media/nrcs-contour-strips.jpg",
        small: "/media/nrcs-contour-strips-sm.jpg",
        alt: "Aerial view of curving bands of green and red-brown crops following the contours of rolling farmland around a farmstead.",
        title: "Contour stripcropping in Allamakee County, Iowa",
        creator: "Tim McCabe, USDA Natural Resources Conservation Service",
        source: "https://commons.wikimedia.org/wiki/File:NRCSIA99370_-_Iowa_(3433)(NRCS_Photo_Gallery).jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/nrcs-farmstead.jpg",
        small: "/media/nrcs-farmstead-sm.jpg",
        alt: "Aerial view of alternating strips of alfalfa, oats and corn curving across a field beyond a farmstead and a country road.",
        title: "Contour strips protect a crop field from erosion in Jasper County, Iowa",
        creator: "Erwin Cole, USDA Natural Resources Conservation Service",
        source: "https://commons.wikimedia.org/wiki/File:NRCSIA99360_-_Iowa_(3413)(NRCS_Photo_Gallery).jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
